module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/for-sale-houses-line-280d7fd1dbbce1e97e44cd135d1e9d5f.svg";